import styled from 'styled-components';

import {
  blue,
  border1,
  boxShadow1,
  gray,
  lightGray,
  whitesmoke,
} from 'utils/style/colors';

import Badge from 'components/Badge';

interface IInfoTextProps {
  align?: 'center' | 'flex-start' | 'flex-end';
}

interface IBoxProps {
  singlePagePrint: boolean;
}

export const RelatedListWrapper = styled('div')`
  display: flex;
  margin: 1em 0;
`;

export const RelatedItemsWrapper = styled('div')`
  margin: 1em 0;
`;

export const RelatedItemBox = styled('div')<IBoxProps>`
  border: 1px dashed ${blue};
  margin: 1rem 0;
  padding: 1rem;
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  background-color: ${gray};
  @media print {
    margin: 2rem 0;
    box-shadow: none;
    page-break-after: ${(props) => (props.singlePagePrint ? 'always' : 'auto')};
    page-break-inside: avoid !important;
  }
`;

export const RelatedItemInfoContainer = styled('div')`
  display: flex;
  margin-bottom: 1rem;
  justify-content: space-between;
  align-items: center;
`;

export const RelatedItemHeader = styled('div')`
  background-color: ${lightGray};
  border-radius: 2rem;
  border: ${border1};
  padding: 1rem;
  margin-bottom: 0.5rem;
`;

export const RelatedItemContent = styled('div')`
  background-color: var(--exact-white);
  margin: 0 1.5rem;
  padding: 0 1rem;
  border-radius: 0.4rem;
  border: ${border1};
`;

export const RelatedItemWrapper = styled('div')`
  margin-bottom: 1.5rem;
`;

export const InfoText = styled('span')<IInfoTextProps>`
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: ${(props) => (props.align ? props.align : 'center')};
  & > i:first-child {
    color: darkgray;
    margin-left: 0.4rem;
    & + span {
      color: darkgray;
      margin-left: 0.8em;
    }
  }
`;

export const TagChip = styled('span')`
  padding: 0 0.5rem;
  word-break: break-word;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: ${whitesmoke};
`;

export const ResponseInfoWrapper = styled('span')`
  flex: 1;
  display: flex;
  flex-direction: column;
  & > span {
    :nth-child(1) ${InfoText} {
      margin-top: 0.5rem;
    }
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const PrintSection = styled('div')`
  display: flex;
  justify-content: space-between;
  border: 1px solid ${blue};
  margin: 1rem 0;
  padding: 1rem;
  flex: 1;
  cursor: pointer;
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  //background-color: #f2f5f7;
  & span {
    color: ${blue};
    margin-right: 1em;
  }
`;

export const PrintIcon = styled('div')`
  color: ${blue};
  cursor: pointer;
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const LoadingRelatedResponsesMessage = styled('span')`
  margin: auto;
  font-weight: 400;
`;

export const QuestionHeaderInfo = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media print {
    page-break-inside: avoid;
  }
`;

export const QuestionTagsWrapper = styled('div')`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  margin-right: 0.2rem;
`;

export const TagChipItem = styled(Badge)`
  font-size: 10px;
  margin-left: 0.5rem;
  margin-top: 0.5rem;
`;

export const RelatedResponsesSelectFilters = styled('div')`
  display: flex;
  & > * {
    &:first-child {
      margin-inline-end: 1rem;
    }
    flex: 1;
  }
`;

export const DistinctiveAnswersWrapper = styled('div')`
  flex: 1;
  display: flex;
  justify-content: center;
`;

export const ViewList = styled.div<{ hiddenIfSmall?: boolean }>`
  width: 50%;
  overflow: hidden;
  margin: 10px 0px;
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  @media only screen and (max-width: 600px) {
    width: 100%;
    margin: 0px;
  }
  @media only screen and (max-width: 600px) {
    ${(props) => (props.hiddenIfSmall ? 'display: none' : '')};
  }
`;

export const ResponsesBody = styled.div`
  max-height: calc(100vh - 360px);
  overflow: scroll;
`;
export const QuestionItems = styled.ul`
  margin: 0;
  flex: 1;

  max-height: calc(100vh - 300px);
  overflow: scroll;
`;
